import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SelvedgeSpecReferenceService extends BaseReferenceService {
  constructor() {
    super('SelvedgeSpecReference');
  }
}
